import React from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import '@purple/semantic-ui-family-connection-theme/components/reset.css';
import '@purple/semantic-ui-family-connection-theme/components/site.css';
import './index.css';

const StandaloneApp = (props) => (
  <div className="components-App-style-app">
    <Header />
    <main className="components-PageTemplate-styles-pageContent">
      <article className="components-PageTemplate-styles-contentWrapper">
        <div className="components-Grid-styles-fc-grid__row">{props.children}</div>
      </article>
    </main>
  </div>
);
StandaloneApp.propTypes = {
  children: PropTypes.element.isRequired,
};

export default StandaloneApp;
